/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_S2_TitleInputs */

const en_guide_json_vs_yaml_xml_s2_title = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON: The Web Standard`)
};

const ko_guide_json_vs_yaml_xml_s2_title = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON: 웹 표준`)
};

const ja_guide_json_vs_yaml_xml_s2_title = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON：Webの標準`)
};

/**
* | output |
* | --- |
* | "JSON: The Web Standard" |
*
* @param {Guide_Json_Vs_Yaml_Xml_S2_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_s2_title = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_S2_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_S2_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_s2_title(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_s2_title(inputs)
	return ja_guide_json_vs_yaml_xml_s2_title(inputs)
});